import { formatDate } from "../../../shared/utils/formatDate";
import { isValidHttpUrl } from "./AnnotationTool";

export default class PhysicianTask {
    id: number;
    dataset_name: string;
    annotation_interface_name: string;
    media_cnt: number;
    type: "image" | "video";
    // Già presenti nella risposta del server (Task, esteso da PhysicianTask lato
    // backend), non ancora letti dal client prima d'ora: bastano da soli a
    // escludere la maggior parte dei task senza gestione dei conflitti, senza una
    // chiamata dedicata per ogni card (v. AnnotationTask.tsx).
    physicians_cnt: number;
    print_function: string;

    physician: number;
    task_url: string;
    deadline: Date;
    annotations: number;

    constructor(obj: PhysicianTask) {
        this.physician = obj.physician;
        this.annotations = parseInt(obj.annotations as any);
        this.deadline = new Date(obj.deadline);
        this.task_url = obj.task_url;

        this.id = obj.id;
        this.dataset_name = obj.dataset_name;
        this.annotation_interface_name = obj.annotation_interface_name;
        this.media_cnt = parseInt(obj.media_cnt as any);
        this.type = obj.type;
        this.physicians_cnt = parseInt(obj.physicians_cnt as any);
        this.print_function = obj.print_function;
    }

    name = () => {
        return `${this.dataset_name} - ${this.annotation_interface_name}`;
    };

    formatDeadline = (): string => {
        return formatDate(this.deadline);
    };

    progress = () => {
        return this.annotations / this.media_cnt;
    };

    isCompleted = () => {
        return this.annotations === this.media_cnt;
    };

    // task_url per un tool integrato è ora un percorso del frontend (es.
    // "/atom/segmentation/47/media"), non un url assoluto verso un
    // servizio esterno - la stessa distinzione assoluto/relativo usata lato admin
    // per base_url (v. AnnotationTool.ts), qui applicata al task_url già
    // completo che il medico deve aprire.
    isExternalTool = (): boolean => {
        return isValidHttpUrl(this.task_url);
    };
}
